import { useContext, useMemo } from 'react';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import { aggregateStrings } from '@bingads-webui-cc-react/account-business-location-legacy-strings';

// composite localization context for the ABL form, merging both legacy and new translation data
// (since the form relies on some old components)
export default function useI18nContext() {
  const i18n = useContext(I18nContext);
  const legacyI18n = useMemo(() => mergeI18n(
    buildLegacyI18n(i18n, [aggregateStrings]),
    i18n
  ), [i18n]);

  const compositeI18n = useMemo(() => mergeI18n(i18n, legacyI18n), [legacyI18n, i18n]);

  return compositeI18n;
}
